module.exports = __webpack_public_path__ + "img/gerente.4798b556.png";